import { CustomElement } from '@aurelia/runtime-html';
import "./footer.scss";
export const name = "footer";
export const template = "<template>\n    <cds-footer\n        currency.bind=\"currencyStorage\"\n        language.bind=\"languageStorage\"\n        ref=\"footerRef\"\n        logo.bind=\"footerLogo\"\n        website.bind=\"shortCode\"\n        discord-href.bind=\"socialMediaDiscord\"\n        twitter-href.bind=\"socialMediaTwitter\"\n        facebook-href.bind=\"socialMediaFacebook\"\n        instagram-href.bind=\"socialMediaInstagram\"\n        navigationrequested.trigger=\"helper.handleNavigationRequested($event)\"\n    ></cds-footer>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
